import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/API';

export interface Announcement {
  id: number;
  title: string;
  content: string;
  created_at: string;
  updated_at: string;
}

interface AnnouncementsResponse {
  announcements: Announcement[];
}

export const useAnnouncements = () => {
  const { data, isLoading, isError } = useQuery<AnnouncementsResponse>({
    queryKey: ['announcements'],
    queryFn: () =>
      API.authenticated.fetch('/announcements').then(r => r.json()),
  });

  return {
    announcements: data?.announcements ?? [],
    isLoading,
    isError,
  };
};
